import { SettlementUploadType } from '../types/settlementUpload.types';

export const ITEMS_PER_PAGE = 15;

export const SETTLEMENT_UPLOAD_TYPE_LABELS: Record<SettlementUploadType, string> = {
    PARTNER: '협력사 주정산',
    RIDER: '라이더 주정산',
};
